import { render, staticRenderFns } from "./TopTwo.vue?vue&type=template&id=a0c91a52&scoped=true&"
import script from "./TopTwo.vue?vue&type=script&lang=js&"
export * from "./TopTwo.vue?vue&type=script&lang=js&"
import style0 from "./TopTwo.vue?vue&type=style&index=0&id=a0c91a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c91a52",
  null
  
)

export default component.exports